import React from "react";
import { motion } from "framer-motion";
import { Check, Star, ArrowRight } from "lucide-react";
import { SectionHeading } from "./shared";
import { PACKAGES } from "../data";

export const Pricing = () => {
  return (
    <section id="pachete" className="bg-[#F8F9FA] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          eyebrow="Pachete"
          title="Pachete transparente, fără costuri ascunse"
          subtitle="Alege pachetul potrivit stadiului afacerii tale. Toate prețurile sunt orientative și pot fi personalizate."
        />

        <div className="mt-16 grid lg:grid-cols-3 gap-6 lg:gap-6 items-center max-w-6xl mx-auto">
          {PACKAGES.map((p, i) => {
            const featured = p.featured;
            return (
              <div key={p.name} className={`relative ${featured ? "lg:scale-105 lg:-my-2 z-10" : ""}`}>
                <motion.div
                  data-testid={`pricing-card-${i}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  whileHover={featured ? undefined : { y: -6 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                  className={`relative rounded-3xl p-8 transition-shadow duration-300 ${
                    featured
                      ? "bg-ink text-white shadow-lift ring-1 ring-black/10"
                      : "bg-white text-ink shadow-subtle ring-1 ring-black/5 hover:shadow-card"
                  }`}
                >
                  {featured && (
                    <span className="absolute -top-4 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-brand px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-white shadow-subtle">
                      <Star className="h-3.5 w-3.5" fill="white" />
                      {p.badge}
                    </span>
                  )}

                  <h3 className={`text-xl font-bold ${featured ? "text-white" : "text-ink"}`}>
                    {p.name}
                  </h3>
                  <p className={`mt-1 text-sm ${featured ? "text-white/60" : "text-ink-muted"}`}>
                    {p.from}
                  </p>

                  <div className="mt-5 flex items-end gap-1.5">
                    <span className={`text-5xl font-extrabold tracking-tight ${featured ? "text-white" : "text-ink"}`}>
                      {p.price}
                    </span>
                    <span className={`mb-2 text-base font-semibold ${featured ? "text-white/70" : "text-ink-muted"}`}>
                      Lei + TVA
                    </span>
                  </div>

                  <div className={`my-7 h-px w-full ${featured ? "bg-white/10" : "bg-gray-100"}`} />

                  <ul className="space-y-3.5">
                    {p.features.map((f) => (
                      <li key={f} className="flex items-start gap-3">
                        <span
                          className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                            featured ? "bg-brand" : "bg-brand-light"
                          }`}
                        >
                          <Check className={`h-3 w-3 ${featured ? "text-white" : "text-brand"}`} strokeWidth={3} />
                        </span>
                        <span className={`text-sm ${featured ? "text-white/85" : "text-ink-muted"}`}>{f}</span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href="#contact"
                    data-testid={`pricing-cta-${i}`}
                    className={`mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition-[background-color,color,border-color] duration-300 ${
                      featured
                        ? "bg-brand text-white hover:bg-brand-hover"
                        : "border border-gray-300 text-ink hover:border-brand hover:text-brand"
                    }`}
                  >
                    Solicită ofertă
                    <ArrowRight className="h-4 w-4" />
                  </a>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
